<template>
  <div :class="contentClasses">
    <img :id="id" class="tooltip-icon" :src="url" />
    <b-tooltip :target="id">
      <div class="tooltip-info">
        {{ message }}
      </div>
    </b-tooltip>
  </div>
</template>

<script>
export default {
  created: function() {
    this.typesDict = {
      ask: 'tooltip_ask',
    }
  },
  computed: {
    url: function() {
      return require(`@/assets/${this.typesDict[this.type]}.svg`)
    },
  },
  props: {
    type: String,
    message: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: function() {
        const number = parseInt(Math.random() * 100000)
        return `${this.type}${number}`
      },
    },
    contentClasses: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>

<style scoped lang="scss">
.tooltip-info {
  color: #000000;
}
</style>
